export default [
  // {
  //   titulo: "Apresentação",
  //   route: "/about/0",
  //   icon: "letra-p.png",
  //   textoHtml: `<article> Olá, Fique à vontade no <strong>Prev-IST</strong>, aqui você poderá
  // encontrar diversas informações sobre as Infecções Sexualmente Transmissíveis (ISTs),
  // assim como, suas formas de prevenção, sobre as diferenças corporais
  // causadas pela puberdade, sobre os métodos contraceptivos e outros conteúdos.
  // <br />

  // Esse aplicativo surgiu como parte do trabalho de conclusão de curso de
  // João Victor Manço Resende da Escola de Enfermagem Aurora de Afonso Costa da
  // Universidade Federal Fluminense (EEAAC-UFF), orientado pelo Dr. Jorge Luiz Lima da
  // Silva (MEP/PPGSC/MPES-UFF). Aproveitem o aplicativo, explorem todas as abas, esclareçam suas dúvidas e
  // compartilhem com seus amigos e familiares. Informação e saúde para todos!</article>
  // <div style="display: flex; justify-content:center; margin-top:32px ">
  //   <video width="80%" height="240" controls>
  //     <source src="https://firebasestorage.googleapis.com/v0/b/pensu-promental.appspot.com/o/appTcc%2Fprev_ist.mp4?alt=media&token=1ad475a2-af82-4a77-b5c0-d31d2ebe7038" type="video/mp4">
  //     Your browser does not support the video tag.
  //   </video>
  // </div>
  // `,
  // },
  {
    titulo: "O que são ISTs?",
    route: "/about/3",
    icon: "ponto-de-interrogacao.png",
    textoHtml: `<article>As Infecções Sexualmente Transmissíveis (ISTs) são ocasionadas por fungos, 
    bactérias, vírus ou outros microrganismos.  
    Sua transmissão ocorre muitas vezes, por via sexual sem a utilização de preservativos, e outras formas de transmissão são através da gestação, amamentação e compartilhamento de 
    objetos pessoais. 
    <br/>
    Ocorreu a substituição da nomenclatura Doenças Sexualmente Transmissíveis (DST) para Infecções 
    Sexualmente Transmissíveis (ISTs), devido a possibilidade de um indivíduo ter e transmitir uma infecção, 
    mesmo sem sinais e sintomas.</article>

    <h3 style="margin-top:16px; margin-bottom: 8px;">Sintomas</h3>

    <article>As ISTs podem se manifestar de diferentes formas como, verrugas, feridas, escorrimento,
     dor pélvica, ardência ao urinar e outras, podendo aparecer principalmente nos órgãos genitais, 
     mas também em outras áreas como boca, mãos e olhos. 
    <br />
    Algumas ISTs podem não apresentar sintomas podendo levar a complicações sérias caso não sejam diagnosticadas
     e tratadas. Devido a isso, é necessário realizar exames laboratoriais para verificar se houve contato com 
     alguma ISTs.
    </article>

    <h3 style="margin-top:16px;">Principais ISTs</h3>

    <article>
  <ol type="I">
    <li>
      <strong>Cancro mole</strong>
      <article>
        O <strong> cancro mole </strong> é causado pela infecção de uma bactéria,
        sendo sua transmissão através da relação sexual sem o uso de preservativos com
        uma pessoa infectada, sendo mais frequente nos homens. <br />
        <br />
        Seus sintomas consistem no aparecimento de feridas múltiplas e dolorosas com
        presença de pus nos órgãos genitais, além de surgimento de nódulos na virilha.
        Nos homens, são mais frequentes o aparecimento no frênulo (freio do pênis) e nas mulheres nos
        pequenos e grandes lábios.
      </article>
      <figure class="d-flex  align-center flex-column">
      <img
        contain
        class="mx-auto"
        src="https://medical-enc.com.ua/myagkiy-shankr.jpg"
        style="max-width: 70%"
      />
      <label class="d-flex justify-center">Fonte: DST, 2021.</label>
    </figure>
      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento adequado
      </p>
    </li>

    <li>
      <strong>DIP</strong>
      <article>
        A <strong>Doença Inflamatória Pélvica (DIP)</strong> é uma síndrome causada
        por diversos microrganismos, ocorrendo em muitos casos quando não houve o
        tratamento da infecção pela clamídia e gonorreia. <br />
        <br />
        Sua transmissão ocorre através da relação sexual desprotegida com pessoas
        infectadas, podendo levar homens e mulheres à infertilidade. Alguns de seus
        sintomas são: dor abdominal; nas costas; febre; vômito; dor ao urinar e
        corrimento vaginal.
      </article>
      <figure class="d-flex  align-center flex-column">
      <img
        contain
        class="mx-auto"
        src="https://static.wixstatic.com/media/5cef64_4db202d7807a4cde98e3b9f1e4643c03~mv2.png/v1/fill/w_1000,h_856,al_c,q_90/5cef64_4db202d7807a4cde98e3b9f1e4643c03~mv2.png "
        style="max-width: 40%"
      />
      <label class="d-flex justify-center">Fonte: Jaleko Artmed, 2021.</label>
    </figure>
      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento adequado
      </p>
    </li>

    <li>
      <strong>Donovanose</strong>
      <article>
        A <strong> donovanose </strong> é uma IST causada por uma bactéria que acomete
        a pele e mucosa das regiões da genitália, virilha e ânus, apresentando uma
        predileção pelas regiões de dobras e região perianal. <br />
        <br />
        Sua transmissão ocorre através de relações sexuais com pessoas infectadas,
        causando ferida de aspecto vermelho vivo e de sangramento, destruindo assim a
        pele da região infectada.
      </article>
      <figure class="d-flex  align-center flex-column">
      <img
        contain
        class="mx-auto"
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSB63QjulT-67yHImN5-4ZZWQ0Jc1H69eM8Tg&s"
        style="max-width: 60%"
      />
      <label class="d-flex justify-center">Fonte: Jaleko Artmed, 2021.</label>
    </figure>
      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento adequado
      </p>
    </li>

    <li>
      <strong>Gonorreia e clamídia</strong>
      <article>
        São infecções causadas por diferentes bactérias, que na maioria das vezes
        estão associadas podendo causar infecção no órgão genital, garganta e olhos. A
        sua transmissão ocorre através da relação sexual desprotegida com uma pessoa
        infectada. <br />
        <br />
        Em mulheres, seus sintomas podem estar relacionados com o corrimento vaginal e
        dor no baixo ventre. Em homens corrimento no pênis e dor ao urinar.
      </article>
      <figure class="d-flex  align-center flex-column">
      <img
        contain
        class="mx-auto"
        src="https://cdn.medizzy.com/B1TqgtaxtAdqL1B6s8SEt_ROBfg=/1067x550/img/posts/18cb5eae-255d-4c80-8b5e-ae255d5c80d9 "
        style="max-width: 60%"
      />
      <label class="d-flex justify-center">Fonte: GoConqr, 2020.</label>
    </figure>
      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento adequado
      </p>
    </li>

    <li>
      <strong>Hepatites virais </strong>
      <article>
        Os vírus hepatotrópico, vírus causadores das hepatites virais (vírus das
        hepatites A, B, C, D e E), são doenças que afetam o tecido do fígado e
        representam cerca de mais de 1,4 milhões de mortes em todo o mundo. No Brasil,
        segundo dados do Ministério da Saúde, cerca de 660 mil pessoas no país possuem
        o vírus da hepatite C, constituindo um problema de saúde pública.
        <figure class="d-flex  align-center flex-column">
          <img
            contain
            class="mx-auto"
            src="https://intranet.canalsaude.fiocruz.br/assets/img/noticias/-2020-07-28-3o5FrOopOr.jpg "
            style="max-width: 60%"
          />
          <label class="d-flex justify-center">Fonte: Fiocruz, 2020.</label>
        </figure>
        <ol>
          <li>
          <strong>Hepatite A</strong>
          
          <article>
            O vírus da hepatite A (HAV) é comumente transmitido através da via
            fecal-oral, sendo assim, por meio de alimentos e água contaminados pelas
            fezes. Contudo, nas últimas décadas observou-se um aumento dos casos
            associados a práticas sexuais que envolvam a possibilidade do contato
            anal-oral. <br /><br />
            Como medida de diminuir as taxas e riscos de infecção, torna-se importante
            incentivar hábitos de higiene antes e após as relações sexuais, assim
            como, o uso de preservativos.<br />
            <br />
            A infecção pelo HAV pode acarretar em alguns sintomas, como: diarreia;
            náuseas; febre; perda de apetite e pele e olhos amarelados.
          </article>
          </li>
          <li>
            <strong>Hepatite B</strong>
            
            <article>
              Segundo dados da Organização Mundial de Saúde, o vírus da hepatite B (
              HBV) infectou mais de dois bilhões de pessoas ao redor do mundo, sendo
              sua evolução silenciosa acarretando a descoberta da doença décadas após
              sua infecção. <br />
              <br />A transmissão dessa doença ocorre através do contato de secreções
              (sangue, sêmen, leite materno e secreção vaginal) com pele e mucosa, pelo
              compartilhamento de objetos de manicure, lâminas de barbear e piercings.
              Além disso, relações sexuais desprotegidas também são uma forma de
              infecção. A infecção pelo vírus da hepatite B geralmente gera poucos
              ou nenhum sintoma característico, sendo necessário assim,
              realizar exames laboratoriais para comprovar o contato com o vírus.
            </article>
          </li>
          <li><strong>Hepatite C</strong></li>
          <article>
            O vírus da hepatite C (HCV) infectou aproximadamente mais de 71 milhões
            de pessoas em todo mundo, muitos dos casos são assintomáticos o que
            dificulta o seu diagnóstico e tratamento. <br />
            <br />
            Seus sintomas geralmente são inespecíficos, podendo levar anos para sua
            manifestação. Sua transmissão ocorre através do contato com sangue
            contaminado,  compartilhamento de agulhas, seringas e outros
            objetos, além da falta de esterilização de equipamentos odontológicos e de
            manicure. Relações sexuais sem preservativos também podem transmitir o
            vírus.
          </article>
        </ol>

        <p class="mt-3 text-caption text-center">
          Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
          serviço de saúde para o diagnóstico correto e indicação do tratamento
          adequado
        </p>
      </article>
    </li>

    <li>
      <strong>HPV</strong>
      <article>
        A infecção pelo <strong>HPV </strong>(Papilomavírus Humano) ocorre através do
        contato direto com a verruga, sêmen e outras secreções que contenham o vírus
        do HPV, podendo infectar a pele e mucosa (oral e genital). <br />
        <br />Essa infecção pode gerar verrugas de aspecto semelhante a uma couve
        flor, nos homens, são mais comuns no pênis e no escroto (saco), nas mulheres, na
        vagina e colo de útero. O ânus também é uma região de aparecimento dessas
        verrugas. <br />
        <br />
        A infecção pelo HPV pode não apresentar sintomas em muitas pessoas, sendo
        assim, pode não manifestar sinais durante meses ou anos. A diminuição da
        imunidade pode provocar a multiplicação do HPV na pessoa infectada, levando
        assim, ao surgimento das lesões.
        <figure class="d-flex  align-center flex-column">
          <img
            contain
            class="mx-auto"
            src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiCn0tif4YE8dhjCc1ofVGjKmI5eGZMiATZhg5pBEBtZTmSWd2mELpZmZNNWQbH-k2Mev4ywHX54JmemxVuf_SviP42TiOWUZ4IpAhTKOuSKZYJaUPmQ8hTm_ebesYr_5Fhcu3VAekcMBc/s320/unnamed.jpg"
            style="max-width: 70%"
          />
          <label class="d-flex justify-center">Fonte: UFPI, 2020.</label>
        </figure>
      </article>

      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento adequado
      </p>
    </li>

    <li>
      <strong>HIV/ AIDS</strong>
      <article>
        O <strong> HIV </strong>(Vírus da Imunodeficiência Humana), quando infecta uma
        pessoa, ataca as células do sistema imunológico responsável pela defesa do
        organismo contra outras doenças. Após a infecção, podem ocorrer sinais e
        sintomas inespecíficos e depois um grande período assintomático que pode durar
        décadas. <br />
        <br />
        A infecção pelo HIV pode apresentar alguns sintomas como a tosse persistente,
        perda de peso, cólicas abdominais, surgimento de lesões orais, placas
        esbranquiçadas sobre a mucosa oral e o comprometimento da memória e
        concentração. <br />
        <br />
        A <strong>AIDS</strong>, sigla em inglês para a Síndrome da Imunodeficiência
        Adquirida, é uma doença do sistema imunológico humano resultante da infecção
        pelo vírus HIV. Sendo assim, ter HIV não significa estar com a síndrome. <br />
        <br />
        A aids/sida se caracteriza pelo enfraquecimento do sistema imunológico do corpo,
        com o organismo mais vulnerável ao aparecimento de doenças oportunistas, como:
        resfriado; infecções respiratórias mais graves como tuberculose; (doenças oportunistas); e até mesmo câncer.

        <figure class="d-flex align-center flex-column">
          <img contain class="mx-auto" style="max-width: 70%" src="https://static.todamateria.com.br/upload/tr/as/trasmissaodohiv-cke.jpg " />
          <label class="d-flex justify-center">Fonte: UFPI, 2020.</label>
        </figure>
      </article>

      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento adequado
      </p>
    </li>

    <li>
      <strong>HTLV</strong>
      <article>
        Das pessoas infectadas pelo vírus do HTLV 1 e 2, cerca de apenas 10% irão
        apresentar sintomas ao longo da vida, sendo assim, sua transmissão silenciosa
        pode atingir diversas pessoas. <br /><br />
        Seus modos de transmissão são: através de práticas sexuais sem preservativos
        com pessoas infectadas; através da gestação, através parto e aleitamento materno, e através do contato com sangue contaminado.
      </article>
      <figure class="d-flex align-center flex-column">
        <img contain class="mx-auto" style="max-width: 50%" src="https://s3.glbimg.com/v1/AUTH_35862ca5c6ab48b992baf1f1b4f7062e/extra-globo-com/incoming/13958127-e29-c3d/w448/17_htlv.jpg " />
        <label class="d-flex justify-center">Fonte: UFPI, 2020.</label>
      </figure>
      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento adequado
      </p>
    </li>

    <li>
      <strong>Sífilis</strong>
      <article>
        Sífilis é uma doença causada por uma bactéria que atinge os humanos, quando
        não tratada pode evoluir para formas graves afetando diversos órgãos e sistema
        nervoso e cardiovascular. Sua transmissão ocorre principalmente através do
        contato sexual desprotegido com uma pessoa infectada, e através da gestação de
        uma mulher com sífilis não tratada. <br /><br />
        A sífilis pode ser dividida em estágios que orientam seus sintomas e
        tratamentos, sendo estes:
        <ul>
          <li>
            - Sífilis primária: fase característica do aparecimento de uma lesão
            denominada de “cancro duro” no local de entrada da bactéria (pênis, vulva,
            vagina, colo uterino, ânus ou boca).
          </li>
          <li>
            - Sífilis secundária: ocorre a cicatrização do cancro e o surgimento de
            manchas róseas pouco visíveis no tronco e membros. Com o tempo essas
            lesões cutâneas se tornam mais visíveis. Há presenças de outros sintomas
            como, febre e mal-estar. - Sífilis latente: período em que não se observa
            nenhum sinal ou sintoma.
          </li>
          <li>
            - Sífilis terciária: estágio no qual ocorre o acometimento do sistema
            nervoso e do sistema cardiovascular, sendo frequente em aproximadamente
            25% dos casos de sífilis não tratada.
          </li>
        </ul>
        <figure class="d-flex align-center flex-column">
          <img class="mx-auto" style="max-width: 70%" src="https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcRInX3IcBProAEI40j9VsyYa8p-eAqbXYRDn8qubU6YlOlmh3PY " />
          <label class="d-flex justify-center">Fonte: UFPI, 2020.</label>
        </figure>
        <p class="mt-3 text-caption text-center">
          Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
          serviço de saúde para o diagnóstico correto e indicação do tratamento
          adequado
        </p>
      </article>
    </li>

    <li>
      <strong>Tricomoníase</strong>
      <article>
        Doença causada por um protozoário, a tricomoníase atinge normalmente mais
        mulheres do que homens sendo aproximadamente 30% de seus casos assintomáticos.
        Além disso, a presença desta infecção está associada com maior facilidade de
        contaminação por outras doenças como a DIP. <br /><br />
        Seus sintomas mais característicos se dão através da presença de corrimento
        vaginal intenso, amarelo-esverdeado, espumoso de odor fétido (semelhante a
        peixe).
        <figure class="d-flex align-center flex-column">
          <img class="mx-auto" style="max-width: 50%" src="https://portalartmed-public.grupoa.education/artmed_blog/b246882a-036d-46c6-be3b-f0c796d3c8e2.png " />
          <label class="d-flex justify-center">Fonte: UFPI, 2020.</label>
        </figure>
        <p class="mt-3 text-caption text-center">
          Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
          serviço de saúde para o diagnóstico correto e indicação do tratamento
          adequado
        </p>
      </article>
    </li>
    <li>
    <strong>Herpes</strong>
    <article>
      Herpes genital: o vírus é conhecido como herpes simples — herpes vírus tipo 2 (HSV-2). 
      Infecção caracterizada pelo aparecimento de vesículas, bolhas e úlceras na pele. 
      Pode causar dor local. Na época de cicatrização, causa coceira e descamação nas lesões. 
      As bolhas e vesículas se tornam úlceras. 
      É transmitida pela secreção das vesículas. 
      Portanto, deve-se evitar o contato com a região afetada pela doença. 
      É sempre bom observar áreas próximas aos genitais, pois sabemos que a camisinha só cobre área específica.
      <figure class="d-flex align-center">
        <img class="mx-auto" style="max-width: 49%" src="https://ep-cms-td-conteudodoc-prd-cdfqcebge4fub7hv.a01.azurefd.net/cms-wordpress/wp-content/uploads/2023/10/12710.jpg " />
      </figure>
      <p class="mt-3 text-caption text-center">
        Na presença de qualquer sinal ou sintoma dessa IST, recomenda-se procurar um
        serviço de saúde para o diagnóstico correto e indicação do tratamento
        adequado
      </p>
    </article>
  </li>
  </ol>
</article>
    `,
  },
  {
    titulo: "Prevenção combinada",
    route: "/about/4",
    icon: "sintomas.png",
    textoHtml: `
    <article>
    A prevenção combinada associa diferentes ações de prevenção ao HIV e as outras ISTs, 
    como as hepatites virais, essas medidas auxiliam os indivíduos a atingirem o estágio de saúde integral. 
    Essas ações podem estar combinadas de acordo com as características individuais, de saúde e de 
    relacionamento de cada pessoa. <br/> <br/>
    Entre os métodos utilizados na prevenção combinada, podemos citar: a testagem para o HIV; a prevenção 
    da transmissão vertical do HIV (grávida para filho); o tratamento das ISTs e das hepatites virais; a imunização para as 
    hepatites A e B; a redução de danos para usuários de álcool e outras drogas; a profilaxia pré-exposição 
    (PrEP); a profilaxia pós-exposição (PEP); e a terapia antirretroviral (TARV). 
    
    <figure class="d-flex  align-center flex-column">
      <img
        contain
        class="mx-auto"
        src="https://unaids.org.br/wp-content/uploads/2022/04/2022_04_30_Mandala-Prevencao-Combinada.jpeg "
        style="max-width: 80%"
      />
      <label class="d-flex justify-center">Fonte: Ministério da Saúde, 2019.</label>
      </figure>
      <ul type="I" style="padding: 0px">
        <li>
          <strong>-	Profilaxia Pós-Exposição (PEP)</strong>
          <p>
          A Profilaxia Pós-Exposição (PEP) de risco à infecção pelo HIV consiste no uso de antirretrovirais, 
          por 28 dias, para reduzir o risco de adquirir essa infecção.<br /> <br/>
          O atendimento após a exposição ao HIV é uma urgência. A PEP deve ser iniciada o mais 
          precocemente possível, tendo como limite as 72 horas subsequentes à exposição. Nos casos em que o 
          atendimento ocorrer após 72 horas da exposição, a PEP não está mais indicada.
          <a href="https://gq.globo.com/sexo/noticia/2024/02/hiv-onde-achar-pep-principais-cidades-brasileiras.ghtml" target="_blank"> Clique aqui </a>para acessar 
          os locais que disponibilizam o tratamento da PEP
          <a href="https://www.gov.br/aids/pt-br/central-de-conteudo/pcdts/2021/hiv-aids/prot_clinico_diretrizes_terap_pep_-risco_infeccao_hiv_ist_hv_2021.pdf" target="_blank"> Saiba mais</a>para acessar 
          
           
          </p>
          <figure class="d-flex  align-center flex-column">
            <img
              contain
              class="mx-auto"
              src="https://gapabs.org.br/wp-content/uploads/2024/09/card_pep_caminho.jpg"
              style="max-width: 80%"
            />
            <label class="d-flex justify-center">Fonte: Agência Aids, 2019.</label>
          </figure>
        </li>
        <li>
          <strong>-	Profilaxia Pré-Exposição (PreEP)</strong>
          <p>
          A Profilaxia Pré-Exposição ao HIV é o método de prevenção à infecção pelo HIV. 
          Esse tratamento consiste na tomada diária de um comprimido que permite ao organismo estar preparado 
          para enfrentar um possível contato com o vírus do HIV. <br/> <br/>
          É importante lembrar que a PreEP não protege contra as outras ISTs, como a Sífilis e as hepatites 
          virais, sendo assim, torna-se necessário a combinação desse método com outras estratégias, como a 
          camisinha. <br/> 
          <strong>Quem pode usar:</strong> <br/>
          A PrEP é indicada para qualquer pessoa em situação de vulnerabilidade para o HIV. Deve ser tomada antes da potencial exposição.
          <br/> <strong>Quanto tempo demora para fazer efeito:</strong>

          <br/>Leva de 2 a 7 dias para alcançar níveis de proteção ideais. Ocorreu uma atualização em 2025 sobre a forma de uso, incluindo o uso sob demanda.
          <a href="https://www.gov.br/aids/pt-br/assuntos/prevencao-combinada/prep-profilaxia-pre-exposicao/prep-profilaxia-pre-exposicao" target="_blank">Clique aqui</a> para acessar os locais que disponibilizam o tratamento da PreEP
          </p>
          <iframe style="display: block; margin: 16px auto" src="https://www.youtube.com/embed/zW30fCnYnq8?si=q-w07RM2KEYjlgXA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          <figure class="d-flex  align-center flex-column">
            <img
              contain
              class="mx-auto"
              src="https://images.prismic.io/vacinapp/afFkWsBOoF08xZtA_prep.png?auto=format,compress"
              style="max-width: 80%"
            />
            <label class="d-flex justify-center">Fonte: G1, 2019.</label>
          </figure>
        </li>

        <li>
          <strong>Camisinha externa</strong>
          <p>
          A camisinha externa é o método eficaz na proteção contra a grvidez e as ISTs, 
          impedindo o contato do pênis com a boca, ânus e vagina. O preservativo é prático, 
          devendo ser usado no momento da relação sexual e descartado em seguida.
          <br/> <br/>
          Para o seu uso seguro, devemos nos atentar para algumas dicas de uso, como: não deixar a 
          camisinha exposta ao sol; não carregar permanentemente em carteira ou bolso; nunca utilizar duas 
          camisinhas ao mesmo tempo; verificar se a embalagem não está furada antes do uso.
          </p> 
          <figure class="d-flex align-center flex-column">
            <img cover class="mx-auto" style="max-width: 50%" src="https://www.treslagoas.ms.gov.br/wp-content/uploads/2025/10/NOVOS-PRESEVATIVOS-21-10-1-scaled.jpg" />
            <label class="d-flex justify-center">Fonte: Tres Lagoas Ms GOV</label>
          </figure>
          <figure class="d-flex align-center flex-column">
            <img cover class="mx-auto" style="max-width: 50%" src="https://images.prismic.io/vacinapp/afFkl8BOoF08xZta_camisinha_masculina.jpg?auto=format,compress" />
            <label class="d-flex justify-center">Fonte: iSaúde, 2012.</label>
          </figure>
        </li>
        <li>
          <strong>Camisinha interna</strong>
          <p>
          A camisinha interna é um tubo feito de plástico resistente, que não diminui o prazer sexual, 
          é colocado dentro da vagina ou ânus para evitar o contato com o pênis sendo eficaz para evitar a 
          gravidez e as ISTs. A camisinha interna deve ser usada em todas as relações sexuais, mesmo 
          durante a menstruação.
          </p> 
          <figure class="d-flex align-center flex-column">
            <img cover class="mx-auto" style="max-width: 50%" src="https://www.meionews.com/uploads/imagens/2016/10/20/entenda-quais-sao-os-beneficios-de-usar-a-camisinha-feminina-c96a3398-3476-4358-835a-4c127817fbf0.jpg " />
            <label class="d-flex justify-center">Fonte: Google</label>
          </figure>
          <figure class="d-flex align-center flex-column">
            <img cover class="mx-auto" style="max-width: 50%" src="https://images.prismic.io/vacinapp/afFk2sBOoF08xZtb_camisinha_feminina.jpg?auto=format,compress" />
            <label class="d-flex justify-center">Fonte: iSaúde, 2012.</label>
          </figure>
        </li>
        <strong>-	O esquema DoxyPEP </strong>
                  <p>
         A doxiciclina, um antibiótico pertencente à classe das tetraciclinas.Este medicamento é muito usado no tratamento de vários tipos de infecções, com a vantagem de ser comprimido de ingestão por via oral.          
         O Ministério da saúde orienta tomar 200mg do antibiótico, ou seja 2, comprimidos de uma só vez em dose única, preferencialmente de 24 horas a no  máximo,  até 72 horas após o sexo oral, anal ou vaginal sem preservativo. Não se deve tomar mais do que uma dose a cada 24h. 
         O médico deverá ser consultado no posto de saúde para receita desse remédio.  Assista ao vídeo a seguir.
         
          <iframe style="display: block; margin: 16px auto"  src="https://www.youtube.com/embed/JgN7QvNoARo?si=OnNUR3UvttQ4wkIZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        <li>
          <strong>-	Testagem regular para ISTs</strong>
          <p>
          O SUS oferece gratuitamente a testagem para o diagnóstico de HIV, sífilis e hepatites C e B. 
          Os testes rápidos são práticos e realizados a partir da coleta de uma gota de sangue, que fornecem o 
          resultado em até 30min. O sistema de saúde também oferece os exames de sangue que são coletados e 
          encaminhados para laudos laboratoriais. <br/> <br/>
          Apesar da eficácia desses exames, todos esses procedimentos possuem um período conhecido como 
          “janela diagnóstica”, período no qual corresponde ao tempo entre o contato com o vírus e a detecção 
          do marcador da infecção no organismo. Sendo assim, em casos de resultados negativos que ainda persista 
          a suspeita de infecção, torna-se aconselhado repetir os testes após 30 dias.
          </p>
          <figure class="d-flex  align-center flex-column">
            <img
              contain
              class="mx-auto"
              src="https://img.vozdascomunidades.com.br/wp-content/uploads/2023/12/07154732/53381783638_9e5f2a09bc_k-900x600.jpg"
              style="max-width: 80%"
            />
            <label class="d-flex justify-center">Fonte: DHOJE, 2018.</label>
          </figure>

          <strong>Estratégias para distribuição do autoteste de HIV no SUS:</strong>

          <p>
            Pares e parcerias sexuais de pessoas em PrEP;
            Distribuição fora dos serviços de saúde por OSC, equipes das de saúde e parceiros em locais de sociabilidade da população chave, em horários alternativos;
            Unidades de saúde: sala para realização do autoteste em privacidade e distribuição para pares e parcerias sexuais de pessoas testadas nos serviços.
            O autoteste atualmente distribuído pelo Ministério da Saúde possui uma tarja vermelha indicando que sua venda é proibida. Caso seja observada alguma intenção de venda, orienta-se denunciar na Ouvidoria (ligação para o 156 ou registrar neste formulário).
          </p>

          <figure class="d-flex  align-center flex-column">
            <img
              contain
              class="mx-auto"
              src="https://antigo.aids.gov.br/sites/default/files/media/pagina/2018/65862_/autotestes.png"
              style="max-width: 80%"
            />
            <label class="d-flex justify-center">Fonte: Gov.br</label>
          </figure>

          <iframe style="display: block; margin: 16px auto" src="https://www.youtube.com/embed/ScZWndMIWfA?si=5a8QvzYaUWdtoLdW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </li>
        <li>
          <strong>-	Tratamento para prevenção</strong>
          <p>
          A adesão ao tratamento e uso dos medicamentos antirretrovirais, em pessoas que vivem com HIV (PVHIV), 
          garantem o controle da doença e prevenindo a evolução para o estágio de aids/sida. As PVHIV que mantêm o 
          tratamento regular apresentam carga viral indetectável, baixa quantidade de vírus circulante no organismo, 
          não irão transmitir, sendo assim, <strong> indetectável é igual intransmissível. </strong>  <br/> <br/>
          Tratamento de outras ISTs também estão disponíveis gratuitamente no SUS, como em casos de sífilis, o 
          tratamento é realizado com injeções do antibiótico penicilina benzatina, variando as doses de acordo com 
          o estágio clínico da doença e sendo necessário repetir o exame para confirmar a cura da doença.
          </p>
          <figure class="d-flex  align-center flex-column">
            <img
              contain
              class="mx-auto"
              src="https://www.gov.br/saude/pt-br/assuntos/noticias/2024/maio/saude-facilita-acesso-a-tratamento-antiviral-a-pacientes-do-rs-que-vivem-com-hiv-e-hepatites/tarv.jpg/@@images/image "
              style="max-width: 80%"
            />
            <label class="d-flex justify-center text-center">TARV- Terapia Antirretroviral<br/> Fonte: DST- São Paulo</label>
          </figure>
        </li>
        <li>
          <strong>-	Vacinação</strong>
          <p>
            <strong>HPV quadrivalente</strong>
        <p>
              -Crianças e adolescentes (9 a 14 anos): dose única.
        <p>
              -Pessoas imunodeprimidas recebem 3 doses:
        <p>
              1ª dose no dia de visita ao posto de saúde ou UBS/ ESF;
        <p>
              2ª dose, 2 meses após a primeira,
        <p>
              3ª dose, 6 meses após a 1ª dose.
        <p>
              -Pessoas vítimas de abuso sexual (9 a 14 anos) 2 doses:
        <p>
              1ª dose no dia de visita ao posto de saúde ou UBS/ ESF;
        </p>
              2ª dose, 6 meses após a 1ª dose.
        <p>
              -Pessoas vítimas de abuso sexual (15 a 45 anos) 2 doses:
        <p>
              1ª dose no dia de visita ao posto de saúde ou UBS/ ESF;
        <p>
              2ª dose, 2 meses após a primeira,
        <p>
              3ª dose, 6 meses após a 1ª dose.
        <p>
              -Pessoas com papilomatose respiratória
        <p>
              1ª dose no dia de visita ao posto de saúde ou UBS/ ESF;
        <p>
              2ª dose, 2 meses após a primeira
        <p>
              3ª dose, 6 meses após a 1ª dose.
        <p>
              -Usuários de PrEP
        <p>
              1ª dose no dia de visita ao posto de saúde ou UBS/ ESF;
        <p>
              2ª dose, 2 meses após a primeira
        <p>
              3ª dose, 6 meses após a 1ª dose.
            </p>
            <p>
          No SUS existe gratuitamente a vacinação para hepatite B, IST altamente transmissível em relações sexuais sem
           preservativos. Para a imunização completa é necessário realizar três doses, sendo, a primeira dose, a 
           segunda dose um mês depois e a terceira dose 6 meses após a primeira. <br/> <br/>
          Outra vacinação também disponível gratuitamente no SUS é para HPV, IST que pode provocar câncer e 
          verrugas genitais. Atualmente a vacina está disponível para meninas entre 9 a 14 anos e meninos de 11 
          a 14 anos. <br/> <br/>
          Em julho de 2024, o Ministério da Saúde anunciou que pessoas que usam a PreP, de 16 a 45 anos, agora podem se vacinar gratuitamente contra o HPV.
          <br/><br/>
          
           <p>
        Atenção: A Secretaria de Estado de Saúde do Rio amplia a partir de 04/08/25, a faixa etária da vacinação contra o HPV (Papilomavírus Humano). 
Procure o posto de saúde mais próximo e se informe! 
</p>
<p>
A meta é vacinar, até dezembro de 2025, 90% do público-alvo: jovens entre 15 e 19 anos que ainda não foram imunizados, totalizando cerca de 520 mil pessoas em todo o estado do Rio de Janeiro. 
</p>
<p>
O HPV é considerado a infecção sexualmente transmissível mais comum do mundo. 
</p>
<p>
Um estudo recente na Inglaterra aponta que a vacinação pode reduzir em 87% as taxas de câncer de colo de útero.
        </p>
        
          Em casos de dúvidas,  procure uma Unidade Básica de Saúde para mais informações e para completar o seu 
          esquema vacinal. Para saber mais sobre vacinas vicite nosso app <a href="https://maisvacinas.netlify.app/" target="_blank">https://maisvacinas.netlify.app/</a>
          </p>
        </li>
        <li>
          <strong>- Novidades no tratamento para HIV</strong>
          <p>
            Desenvolvido pela farmacêutica Gilead Sciences, sediada nos EUA, o lenacapavir comercializado desde 2022, mas indicado apenas para pessoas infectadas com resistência a antirretrovirais comuns.
          </p>
          <p>
            O medicamento atua por um mecanismo diferente: enquanto a maioria dos antirretrovirais interfere na produção do material genético do HIV, o lenacapavir impede a formação do chamado capsídeo, estrutura que guarda o RNA do vírus e possibilita sua entrada no interior das células. Ao bloquear esse processo, o HIV é impedido de se replicar, o que mantém a infecção controlada.
          </p>
          <p>
            O medicamento injetável aplicado somente duas vezes por ano se provou tão eficaz que o estudo clínico chegou a ser interrompido precocemente.
          </p>
          <p>
            Saiba mais em <a href="https://g1.globo.com/saude/noticia/2024/07/24/remedio-injetavel-aplicado-duas-vezes-por-ano-e-100percent-eficaz-na-prevencao-do-hiv-mostra-estudo.ghtml" target="_blank"> Clique aqui </a>
          </p>
        </li>
      <ul>
    </article>
    `,
  },
  {
    titulo: "Puberdade",
    route: "/about/5",
    icon: "letra-p.png",
    textoHtml: `
    <article>
      É necessário que todos tenham o conhecimento sobre o funcionamento do seu corpo. 
      Esse saber os auxilia na saúde reprodutiva e  favorece os cuidados de prevenção contra as 
      Infecções Sexualmente Transmissíveis e outras doenças que possam afetar a saúde sexual e a 
      saúde reprodutiva.<br> <br/>
      A puberdade, período no qual o adolescente apresenta um conjunto de transformações no corpo, 
      nos sentimentos, no humor, nas responsabilidades e no modo de enxergar o mundo, pode ser 
      exemplificado nos seguintes itens: 
      <ul style="padding: 0px">
        <li>
          -	Estirão do crescimento: processo de aceleração do crescimento estatural, 
          geralmente iniciado pelas mãos e pés marcando  início da fase da adolescência. 
        </li>
        <li>
          -	Maturação sexual: desenvolvimentos das características sexuais secundárias, 
          que veremos a seguir separadamente. 
        </li>

      <iframe style="display: block; margin: 16px auto" src="https://www.youtube.com/embed/hP-tT23lAOQ?si=2_pqVa57hS7XuL55" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

      </ul>
      

      <ul type="I" >
        <li>
          <br/><strong>Masculino</strong> <br/>
          Na maturação sexual do sexo masculino, as transformações que ocorrem durante o período da puberdade, são:
          <ul>
            <li>
              -	Aumento do volume testicular;
            </li>
            <li>
              -	Crescimento dos pelos pubianos; 
            </li>
            <li>
              -	Desenvolvimento do pênis em comprimento e diâmetro; 
            </li>
            <li>
              -	Crescimento dos pelos na axila e na face.
            </li>
          </ul>
          <figure class="d-flex  align-center flex-column">
            <img
              contain
              class="mx-auto"
              src="https://www.fcm.unicamp.br/adolescentes/sites/default/files/inline-images/Apresenta%C3%A7%C3%A3o%20sem%20t%C3%ADtulo%20(2).jpg "
              style="max-width: 100%"
            />
            <label class="d-flex justify-center">Estágios de desenvolvimento órgão sexual masculino <br/> Fonte: Ministério da Saúde, 2013.</label>
          </figure>
          </li>
        <li>
          <br/> <strong>Feminino</strong> <br/>
          Na maturação sexual do sexo feminino, as transformações que ocorrem durante o período da puberdade, são:
          <ul>
            <li>
              -	Surgimento do broto mamário (mamas);
            </li>
            <li>
              -	Crescimento dos pelos na genitália e nas axilas; 
            </li>
            <li>
              -	Aumento do tamanho do quadril; 
            </li>
            <li>
              -	Ocorre a primeira menstruação, conhecida como menarca. 
            </li>
          </ul>
          <figure class="d-flex  align-center flex-column">
            <img
              contain
              class="mx-auto"
              src="https://www.fcm.unicamp.br/adolescentes/sites/default/files/inline-images/Apresenta%C3%A7%C3%A3o%20sem%20t%C3%ADtulo%20(3).jpg "
              style="max-width: 100%"
            />
            <label class="d-flex justify-center text-center">Estágios de desenvolvimento das mamas <br/> Fonte: Ministério da Saúde, 2013</label>
          </figure>

          <iframe style="display: block; margin: 16px auto" src="https://www.youtube.com/embed/tGrks1qY_7A?si=xKttBjHc8PGa_MP2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </li>
      <ul>
      
    </article>
    `,
  },
  {
    titulo: "Métodos contraceptivos",
    route: "/about/6",
    icon: "pilulas.png",
    textoHtml: `
    <article>
      <ol type="I">
        <li>
          <strong>O que são?</strong>
          <p>
          Os métodos contraceptivos são maneiras que através de medicamentos, cirurgias ou objetos  visam evitar a gravidez, 
          existem disponíveis diferentes métodos femininos e masculinos. Alguns desses métodos são considerados 
          reversíveis, sendo assim após a interrupção do seu uso, ocorre o retorno da capacidade de engravidar. 
          Entretanto, existem procedimentos irreversíveis, como a vasectomia. <br /> <br />  
          A escolha do método contraceptivo deve ser livre, respeitando a decisão daquele que irá fazer o uso, 
          levando em consideração as suas vantagens e desvantagens e as condições de vida e saúde do indivíduo. 
          Para isso, torna-se  importante procurar um serviço de saúde para receber informações sobre os métodos anticoncepcionais 
          disponíveis e para obter o método escolhido que estão disponíveis no Sistema Único de Saúde (SUS).
          </p>
          <p class="text-caption" style="text-align: center">Nesta seção, iremos abordar alguns dos diferentes tipos de métodos contraceptivos e suas vantagens e desvantagens. </p>
          <figure class="d-flex align-center flex-column">
            <img contain class="mx-auto" style="max-width: 70%" src="https://emfoco.med.br/wp-content/uploads/2024/04/anticoncepcional.jpg.webp" />
            <label class="d-flex justify-center">Fonte: BBC, 2018.</label>
          </figure>
        </li>
        <li>
          <strong>Quais são?</strong>
          <ol>
            <li>
            <strong>Pílulas anticoncepcionais</strong>
            <p>
            As pílulas anticoncepcionais são métodos hormonais que impedem a ovulação e dificultam a passagem dos espermatozóides.
             Esse método é indicado para qualquer mulher, adolescente ou adulta, sendo recomendado o uso diário 
             preferencialmente no mesmo horário, em casos de esquecimento, deve-se tomar a pílula de imediato.
            <br/> <br/>
            Alguns efeitos colaterais ao uso desses hormônios são relatados, como:  diminuição da quantidade e dias de 
            sangramento; alterações de peso; alterações de humor; e dores de cabeça. Contudo, seu uso ajuda na proteção 
            contra a gravidez, doença inflamatória pélvica e ajudam na redução das cólicas menstruais. 
            Além disso, as pílulas anticoncepcionais não protegem contra as ISTs.
            </p>
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 70%" src="https://www.buscofem.com.br/assets/images/dicas/como-funcionam-as-pilulas-os-anticoncepcionais-orais.png_596639839f5679.79653353.png " />
              <label class="d-flex justify-center">Fonte: BBC, 2018.</label>
            </figure>
            </li>
            <li>
              <strong>Injeções anticoncepcionais</strong>
              <p>
              As injeções anticoncepcionais são feitas de hormônios parecidos com os produzidos pelo corpo, 
              impedindo a ovulação. Existem diferentes opções dessas injeções, sendo possível optar 
              pela injeção mensal ou trimestral.
              <br/> <br/>
              Alguns efeitos colaterais podem ser observados após três meses, como sangramento irregular ou 
              prolongado, e após um ano, como, ausência de menstruação. Esse método pode reduzir sintomas de 
              endometriose e ajudar no ganho de peso.
              </p> 
              <figure class="d-flex align-center flex-column">
                <img cover class="mx-auto" style="max-width: 100%" src="https://www.dicasdemulher.com.br/wp-content/uploads/2023/04/injecao-anticoncepcional-000.png " />
                <label class="d-flex justify-center">Fonte: TuaSaúde, 2020.</label>
              </figure>
            </li>
            <li>
              <strong>Camisinha externa</strong>
              <p>
              A camisinha externa é o método eficaz na proteção contra a grvidez e as ISTs, 
              impedindo o contato do pênis com a boca, ânus e vagina. A camisinha é prática, 
              devendo ser usada no momento da relação sexual e descartada em seguida.
              <br/> <br/>
              Para o seu uso seguro, devemos nos atentar para algumas dicas de uso, como: não deixar a 
              camisinha exposta ao sol; não carregar permanentemente em carteira ou bolso; nunca utilizar duas 
              camisinhas ao mesmo tempo; verificar se a embalagem não está furada antes do uso.
              </p> 
              <figure class="d-flex align-center flex-column">
                <img cover class="mx-auto" style="max-width: 50%" src="https://www.treslagoas.ms.gov.br/wp-content/uploads/2025/10/NOVOS-PRESEVATIVOS-21-10-1-scaled-420x280_c.jpg" />
                <label class="d-flex justify-center">Fonte: Google</label>
              </figure>

            </li>
            <li>
              <strong>Camisinha interna</strong>
              <p>
              A camisinha interna é um tubo feito de plástico resistente, que não diminui o prazer sexual, 
              é colocado dentro da vagina ou ânus para evitar o contato com o pênis sendo eficaz para evitar 
              gravidez e  ISTs. A camisinha interna deve ser usada em todas as relações sexuais, mesmo 
              durante a menstruação.
              </p> 
              <figure class="d-flex align-center flex-column">
                <img cover class="mx-auto" style="max-width: 50%" src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Pr%C3%A9servatif_f%C3%A9minin.jpg/1920px-Pr%C3%A9servatif_f%C3%A9minin.jpg " />
                <label class="d-flex justify-center">Fonte: Google</label>
              </figure>
            </li>
            <li>
            <strong>Diafragma</strong>
            <p>
            É uma capa flexível, com uma borda em forma de anel, que é colocada na vagina cobrindo o colo 
            do útero. Esse método evita a gravidez impedindo a entrada dos espermatozóides dentro do útero, 
            contudo não previne contra as ISTs. Existem diafragmas de diversos tamanhos, sendo necessária a 
            medição por profissional de saúde para determinar o mais adequado para cada mulher.
            <br /> <br /> 
            O diafragma não deve ser utilizado em períodos de menstruação, e deve ser retirado de seis a 
            oito horas após a última relação sexual.
            </p> 
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 80%" src="https://www.greenme.com.br/wp-content/uploads/2018/02/diafragma-como-usar.jpg" />
              <label class="d-flex justify-center">Fonte: BBC, 2018.</label>
            </figure>
          </li>
          <li>
            <strong>Dispositivo intraUterino (DIU)</strong>
            <p>
            O Dispositivo Intra-Uterino (DIU) é um objeto colocado no interior do útero para evitar a gravidez, 
            podendo ser recoberto por cobre ou conter hormônio. O DIU não provoca aborto, pois impede o encontro do 
            espermatozóide com o óvulo. <br/> <br/>
            A mulher que usa DIU pode apresentar aumento do sangramento menstrual e aumento na duração da menstruação 
            ou apresentar cólicas. Esse dispositivo deve ser colocado por um profissional de saúde treinado e a 
            capacidade de engravidar retorna, após a retirada do DIU. Esse método não previne contra as ISTs. 
            </p> 
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 80%" src="https://www.febrasgo.org.br/media/k2/items/cache/ccb4e23c8aa216f1e96d31ab209c036b_L.jpg" />
              <label class="d-flex justify-center">Fonte: BBC, 2018.</label>
            </figure>
          </li>
          <li>
            <strong>Tabela</strong>
            <p>
            A tabela é um método que se baseia na observação de vários ciclos menstruais, 
            para determinar o período fértil do ciclo menstrual da mulher, sendo sua eficácia maior se o 
            casal não tiver relação sexual com penetração vaginal no período fértil.
            <br /> <br />
            O método da tabela não é indicado em alguns casos, como após o parto ou durante a amamentação, 
            ou para adolescentes e mulheres na pré-menopausa que estejam apresentando ciclos menstruais irregulares. 
            Esse método não previne contra as ISTs. 
            </p> 
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 80%" src="https://s1.static.brasilescola.uol.com.br/be/conteudo/images/491933b351299f9745efff02603e6130.jpg" />
              <label class="d-flex justify-center">Fonte: : Brasil Escola, 2021.</label>
            </figure>
          </li>
          <li>
            <strong>Coito interrompido </strong>
            <p>
            O método do coito interrompido consiste na retirada do pênis da vagina um pouco antes da ejaculação.
             Contudo, além de não proteger contra as ISTs, esse método não deve ser estimulado
              como método anticoncepcional, devido a grande possibilidade de falha. 
            </p> 
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 50%" src="https://pt.quizur.com/_image?href=https%3A%2F%2Fdev-beta.quizur.com%2Fstorage%2Fv1%2Fobject%2Fpublic%2F%2Fimagens%2F%2F20336128%2Fad0f9259-cdc5-4faa-8241-d44a98622b20.png&w=400&h=400&f=webp " />
              <label class="d-flex justify-center">Fonte: UFC, 2017.</label>
            </figure>
          </li>
          <li>
            <strong>Vasectomia</strong>
            <p>
            A vasectomia consiste em uma cirurgia simples, que se faz em homens que não desejam mais ter filhos. 
            É um método anticoncepcional considerado permanente ou irreversível, agindo impedindo que os espermatozóides
             se encontrem com o óvulo.
            </p> 
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 50%" src="https://urocentro.com/wp-content/uploads/2024/01/aa222-300x204-1.png" />
              <label class="d-flex justify-center">Fonte: Mater Prime, 2021.</label>
            </figure>
          </li>
          <li>
            <strong>Pílula anticoncepcional de emergência</strong>
            <p>
            As pílulas anticoncepcionais de emergência, conhecidas como “pílulas do dia seguinte”, 
            ajudam a prevenir a gravidez após a relação sexual desprotegida, quando ingerida até 5 dias 
            após a exposição. São indicados em casos de relações sexuais sem consetimento, sem o uso de 
            preservativos ou com seu uso incorreto. Contudo, esse método não interrompe uma gravidez já existente.
            <br /> <br/>
            Alguns efeitos colaterais podem ser observados, como: alterações nos padrões de sangramento; náuseas; 
            fadiga; e dor abdominal.  
            </p> 
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 50%" src="https://s3.glbimg.com/v1/AUTH_35862ca5c6ab48b992baf1f1b4f7062e/extra-globo-com/incoming/15226011-f8d-67a/w448/pilula-do-dia-seguinte_web.jpg" />
              <label class="d-flex justify-center">Fonte: BBC, 2019.</label>
            </figure>
          </li>
          <li>
            <strong>O que é o chip anticoncepcional? (implanon)</strong>
            <figure class="d-flex align-center flex-column">
              <img cover class="mx-auto" style="max-width: 50%" src="https://s2-oglobo.glbimg.com/ZigPVnyxnchHqcElqmyn9upHFa4=/54x0:572x244/888x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_da025474c0c44edd99332dddb09cabe8/internal_photos/bs/2025/y/4/596g31QCqoA2MBq7ubIQ/homepage-2022-product-box.jpg" />
            </figure>
            <p>
              O chip anticoncepcional é um tipo de implante usado para evitar gravidez. Ele é pequeno, parece um palitinho, com cerca de 4 centímetros de comprimento. Dentro dele tem um hormônio chamado etonogestrel, parecido com a progesterona, que é um hormônio feminino.
            </p>
            <p>
              Esse hormônio vai sendo liberado aos poucos no corpo. Isso impede que a mulher ovule (libere óvulo) e também deixa o muco do útero mais grosso, dificultando a entrada dos espermatozoides. Assim, a gravidez é evitada.
            </p>
            <p>
              No Brasil, o único chip aprovado oficialmente é o <strong>Implanon</strong>, que passou por vários estudos e foi reconhecido pela Anvisa. Ele funciona muito bem e tem uma vantagem: a mulher não precisa lembrar de tomar remédio todo dia ou todo mês. O chip faz tudo sozinho.
            </p>
            <p>
              Atualmente, pode ser fornecido pelo SUS com a indicação do serviço de saúde (unidade básica, saúde da família ou policlínica).
            </p>
            <strong>Implanon engorda? O que você precisa saber</strong>
            <p>
              Muitas mulheres se preocupam com o peso quando escolhem um método anticoncepcional. Mas pode ficar tranquila: o implante Implanon <strong>não causa ganho de peso direto</strong>. Em poucos casos, pode acontecer <strong>retenção de líquido</strong>, o que provoca <strong>inchaço</strong>. Isso é raro.
            </p>
            <p>
            Mulheres que já têm tendência a engordar podem sentir esse inchaço nos primeiros <strong>6 meses</strong> depois de colocarem o chip. Se isso acontecer, não se preocupe: você estará acompanhada por um profissional que vai te ajudar com qualquer sintoma após o procedimento.
            </p>
            <p>
             Para evitar esse tipo de problema:
            <ul>
              <li>
                Se alimente  de forma saudável, evite produtos ultraprocessados
              </li> 
              <li>
                Pratique atividades físicas 🏃‍♀️♀️
              </li>
             </ul>
            </p>
            <p>Também pode surgir acne (espinhas) em quem tem a pele mais oleosa. Nesse caso, vale procurar um dermatologista ou ginecologista para acompanhar e orientar.</p>

            <p>Outro possível efeito é o chamado escape menstrual, que é um pequeno sangramento fora do período da menstruação. É bem raro, mas se acontecer, fale com seu médico.</p>

            <p>Quem pode usar o chip anticoncepcional?</p>

            <p>O chip anticoncepcional é uma boa opção para mulheres que querem evitar gravidez de forma prática e segura. Ele é especialmente indicado para quem não pode usar o DIU ou tem problemas com estrogênio, um hormônio presente na maioria das pílulas anticoncepcionais.</p>

            <p>Se você tem <strong>endometriose</strong> ou quer diminuir o fluxo menstrual e as cólicas o Implanon pode ajudar.</p>

            <p>Porém, o chip não é indicado para:</p>

            <ul>
              <li>Quem tem problemas no fígado</li>
              <li>Quem sofre de sangramento vaginal fora do comum</li>
              <li>Quem tem alergia ao hormônio etonogestrel ou a esteroides sexuais</li>
              </ul>

            <p>⚠️ E o mais importante: sempre procure o serviço de saúde, pois a enfermeira pode te orientar e indicar o médico para acompanhamento!</p>

          </li>
          </ol>
        </li>
        
      <ol>
    </article>
    `,
  },
  {
    titulo: "Violência sexual ",
    route: "/about/7",
    icon: "violencia.png",
    textoHtml: `
    <article>
    A violência sexual é compreendida como a realização de práticas sexuais contra a vontade da pessoa, 
    podendo ocorrer em ambientes públicos ou privados, acontecendo por meio do uso da força, ameaça ou 
    influência psicológica e uso de drogas. <br/> <br/>
    Segundo o Ministério da Mulher, da Família e dos Direitos Humanos, o abuso sexual é compreendido como 
    toda ação que se utiliza da criança ou do adolescente para fins sexuais, sendo realizado de modo presencial 
    ou por meio eletrônico, para estimulação sexual do abusador ou de terceiros. Pessoas acometidas por essas 
    ações de violência e abuso sexual, passam por atendimentos de proteção, prevenção de novas situações e 
    medidas para responsabilizar os agressores <br/><br/>
    No atendimento de saúde, são ofertados para as vítimas de violência sexual serviços psicológico imediato, 
    profilaxia do HIV e das outas ISTs, imunização do HBV, testagem para sífilis, HIV e as hepatites virais B 
    e C. Em casos que resultam em gravidez, torna-se garantido o acesso aos serviços de referência para a 
    interrupção da gravidez nos casos previstos pela lei, sendo levado em consideração a anatomia e decisão da 
    mulher.

    <figure class="d-flex  align-center flex-column">
      <img
        contain
        class="mx-auto"
        src="https://pt.org.br/wp-content/uploads/2025/12/ligue-180-divulgac3a7c3a3o-4.jpg"
        style="max-width: 80%"
      />
      <p><a href="https://leidominutoseguinte.mpf.mp.br/" taget="blank">Lei do Minuto Seguinte - Ministério Público Federal</a></p>
    </figure>

    <p>Entendendo o estupro virtual</p>

    <p>O estupro virtual é reconhecido legalmente como um crime grave, com a mesma seriedade de um estupro cometido no ambiente físico. A legislação brasileira não faz distinção entre o "mundo real" e o virtual, e a vítima pode ser homem ou mulher.</p>

    <p>Conforme a Lei 12.015/09, que alterou o Código Penal em 2009, o conceito de estupro foi ampliado. Anteriormente, a penetração era um elemento essencial para a configuração do crime. Atualmente, o Artigo 213 do Código Penal define estupro de forma mais abrangente como:</p>

    <p>"Constranger alguém, mediante violência ou grave ameaça, a ter conjunção carnal ou a praticar ou permitir que com ele se pratique outro ato libidinoso."</p>

    <p>Isso significa que atos como masturbação ou sexo oral, realizados sob coerção ou ameaça, também se enquadram na definição de estupro, independentemente de ocorrerem presencialmente ou por meios virtuais.</p>

    <p>Por ser considerado um crime hediondo, o estupro virtual não permite fiança e a pena varia de 6 a 10 anos de reclusão.</p>

    <p>A abrangência do "ato libidinoso" e as formas do estupro virtual</p>

    <p>O termo "ato libidinoso" abarca qualquer conduta que vise à satisfação sexual, e no contexto virtual, isso se manifesta de diversas maneiras, mesmo sem a possibilidade de "conjunção carnal" (relação sexual com penetração). A internet e as redes sociais facilitam a prática desses atos sem contato físico, tornando o estupro virtual uma realidade complexa e multifacetada.</p>

    <p>Como o estupro virtual pode ocorrer</p>

    <p>O estupro virtual pode ser perpetrado por pessoas já conhecidas da vítima no mundo real, que podem usar informações ou materiais comprometedores para chantagem. No entanto, ele também pode surgir de interações com "contatinhos" online, onde o envio voluntário de "nudes" (fotos ou vídeos íntimos) despretensiosamente pode se tornar uma ferramenta para a coerção.</p>

    <p>Além disso, ataques hackers representam outra via para o estupro virtual. Criminosos podem invadir dispositivos como computadores e celulares, acessando e roubando fotos e vídeos íntimos. Com esse material em mãos, a vítima é então chanteada para a realização de atos libidinosos, como se expor pela webcam.</p>

    <p>As consequências psicológicas</p>

    <p>As consequências psicológicas de um estupro virtual podem ser tão devastadoras quanto as de um estupro físico. Vítimas frequentemente experimentam sentimentos intensos de humilhação, angústia, raiva (direcionada tanto a si quanto ao agressor), medo, culpa e desespero. Esses traumas podem levar ao desenvolvimento de condições graves como Transtorno de Estresse Pós-Traumático (TEPT), síndrome do pânico e depressão.</p>

    <p><a href="https://www.migalhas.com.br/arquivos/2025/5/96709F10DC9470_InterfacescomofenomenoInceleos.pdf" target="_blank"><strong>Saiba mais neste artigo</strong></a></p>

    </article>
    `,
  },
  {
    titulo: "Vídeos",
    route: "/about/8",
    icon: "video.png",
    textoHtml: `
    <div class="d-flex align-center flex-column" style="gap: 0.5rem">
      <iframe 
        width="350"
        height="200"
        src="https://www.youtube.com/embed/NMJwmdTYpZo"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
        <iframe
          width="350"
          height="200"
          src="https://www.youtube.com/embed/ofo6N5hhdVc"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
        <iframe
          width="350"
          height="200"
          src="https://www.youtube.com/embed/OMyYuyaCUxA"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
        <iframe
          width="350"
          height="200"
          src="https://www.youtube.com/embed/DoYZz2p4CQc?si=NiCGXZRR4bI3g60T"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
       <iframe 
          width="350"
          height="200" 
          src="https://www.youtube.com/embed/u8APt4-vXaQ?si=XYphVLAHxWfDrMUW" 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <iframe 
            width="350"
            height="200" 
            src="https://www.youtube.com/embed/b-9wAtI0O4E?si=TTj1rNOA0t4yJEOg" 
            title="YouTube video player" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
          </iframe>
        <iframe width="350" height="200" src="https://www.youtube.com/embed/YdvxCiK7_04?si=dkW6DsAAwhX7u5mn" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <iframe width="350" height="200" src="https://www.youtube.com/embed/aEv8L-cGV4A?si=u9G_xTLx-9su9Xnl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <iframe width="350" height="200" src="https://www.youtube.com/embed/od0yb0INBpA?si=ydQF6_57Fgyhw3lI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <iframe width="350" height="200" src="https://www.youtube.com/embed/9vx998WrKho?si=0r2GeUwmJjw-2QSD" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    `,
  },
  {
    titulo: "Unidades de Saúde",
    route: "/unidadesdesaude",
    icon: "saude.png",
  },
  {
    titulo: "Sobre nós",
    route: "/quemSomos",
    icon: "sobre-nos.png",
  },
  {
    titulo: "MPOX",
    route: "/about/9",
    icon: "mpox.gif",
    textoHtml: `
    <div class="flex-grow-1">
      <article>
        <p>
        Antes conhecida como varíola dos macacos, mas hoje a doença é transmitida também de humanos para humanos.
        O surto é no continente africano, mas pelo Brasil há casos notificados, principalmente, no RJ e SP. O alerta da OMS pede para que os países fiquem mais alertas para um novo subtipo que pode se espalhar, mas calma que não é uma pandemia!
        Sintomas: febre, dor de cabeça, dor no corpo, coceira, cansaço, enjoo e vômitos. 
        Sinais: indivíduo de qualquer idade que apresente início súbito de lesão em mucosas (boca, anus, vagina, olho) E/OU erupção de pele aguda sugestiva de Mpox, única ou várias, em qualquer parte do corpo, ínguas (linfonodos inchados).
        As fases da doença na pele são: específicos com máculas, pápulas, vesículas, pústulas e crostas, neta sequência.
        </p>

        <figure class="d-flex  align-center flex-column">
          <img
            contain
            class="mx-auto"
            src="https://www.ufrgs.br/telessauders/wp-content/uploads/2022/06/monkeypox-ilustracao-800x287.jpg"
            style="max-width: 80%"
          />
          <label class="d-flex justify-center">Fonte: WHO, 2022</label>
        </figure>

        <p>
          Transmissão: de pessoa para pessoa por contato direto com lesões / feridas na pele  (máculas, pápulas, vesículas, pústulas, úlceras ou crostas), fluidos corporais ou materiais contaminados, como roupas, lençóis e objetos de higiene pessoal. 
        </p>

        <p>
          O vírus mpox pode sobreviver por até 90 horas em superfícies.
        </p>

        <p>
          Pode também ser transmitido por meio de gotículas respiratórias, com contato pessoal próximo e/ou prolongado.
        </p>
        <p>
          O que fazer?
        </p>
        <p>
          Buscar atendimento na unidade básica de saúde informar sobre as pessoas que você teve contato. Os profissionais vão avaliar e saber a melhor conduta.
        </p>
        <p>
          Os doente devem se isolar por 21 dias, evitando contato e com distancia de 1,5m.
        </p>

        <p>
        Vacinação: a vacina existente é para um público alvo e tem objetivo de evitar com que os mais vulneráveis desenvolvam a doença (grávidas, portadores de HIV, pessoas com câncer, profissionais de laboratório). A aplicação da vacina após a exposição o vírus deve ocorrer no caso de pessoas que tiveram contato direto com secreções e fluidos corporais de pessoas suspeita (será avaliado pelo profissional).
        </p>
        <p>
        Mais informações em:  <a href="https://www.uff.br/sites/default/files/informes/-informe_tecnico_mpox_uff_final_para_reitoria.pdf" taget="blank">informe_tecnico_mpox_uff_final_para_reitoria.pdf</a> <br />
        Assista ao vídeo e se inscreva em nosso canal: https://youtu.be/u8APt4-vXaQ
        </p>

        <iframe 
          width="350"
          height="200" 
          src="https://www.youtube.com/embed/u8APt4-vXaQ?si=XYphVLAHxWfDrMUW" 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        
      </article>
    </div>
    `,
  },
  {
    titulo: "Prêmios",
    route: "/about/1",
    icon: "recompensa.png",
    textoHtml: `
    <div class="flex-grow-1">
        <h1 class="gradient-text d-flex align-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4604/4604793.png"
            class="mr-3"
            style="max-width: 32px; max-height: 32px"
          ></img>
          Prêmios
        </h1>
        <article class="my-3">
          <h2 class="d-flex align-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2583/2583256.png"
              class="mr-3"
              style="max-width: 24px; max-height: 24px"
            ></v-img>
            <span> 17 <sup>a</sup> Semana científica HESFA/UFRJ</span>
          </h2>
          <p class="px-2 font-weight-medium">
            1 <sup class="text-decoration-underline">o</sup> lugar na categoria
            Emergências e reemergências em Saúde
          </p>
          <a class="certificado" open-image="cert17semanacientifica.png"> 
            Certificação 
          </a>
        </article>
        <article class="my-3">
          <h2 class="d-flex align-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2583/2583256.png"
              class="mr-3"
              style="max-width: 24px; max-height: 24px"
            >
            <span> XXIV SEMANA CIENTÍFICA DA EEAAC - UFF</span>
          </h2>
          <p class="px-2 font-weight-medium">
            1 <sup class="text-decoration-underline">o</sup> lugar Prêmio
            Rosalda da Cruz Nogueira Paim Saúde
          </p>
          <a class="certificado" open-image="certrosalda.png"> 
            Certificação 
          </a>
        </article>
          <h2 class="d-flex align-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2583/2583256.png"
              class="mr-3"
              style="max-width: 24px; max-height: 24px"
            >
            <span>
              Ivone Lara - A enfermeira por trás do samba
            </span>
          </h2>
          <p class="px-2 font-weight-medium">
            Inovação sustentabilidade
          </p>
          <a class="certificado" open-image="corenrj.jpg"> Certificação </a>
          <p class="mt-2 mb-0">
            <strong> Matérias na mídia: </strong>
          </p>
          <p>
            <a target="_blank" href="http://www.coren-rj.org.br/coren-rj-divulga-lista-dos-profissionais-agraciados-para-o-premio-ivone-lara-a-saude-por-tras-do-samba_31800.html">
              Coren-RJ divulga lista dos profissionais agraciados para o Prêmio Ivone Lara: a saúde por trás do samba
            </a>
          </p>
        </article>
        </article>
          <h2 class="d-flex align-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2583/2583256.png"
              class="mr-3"
              style="max-width: 24px; max-height: 24px"
            ></v-img>
            <span>
              Excelência Científica
            </span>
          </h2>
          <a class="certificado" open-image="certUFF.jpeg"> Certificação </a>
          <p class="mt-2 mb-0">
            <strong> Matérias na mídia: </strong>
          </p>
          <p>
            <a target="_blank" href="https://www.uff.br/informe/uff-valoriza-pesquisas-de-sua-comunidade-com-premio-de-excelencia-cientifica/">
              UFF valoriza pesquisas de sua comunidade com Prêmio de Excelência Científica
            </a>
          </p>
        </article>
        <article class="my-3">
          <h2 class="d-flex align-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2583/2583256.png"
              class="mr-3"
              style="max-width: 24px; max-height: 24px"
            ></v-img>
            <span>Laboratório de Inovação em Saúde - Vigilância em Saúde e Ambiente (LIS-VIG)</span>
          </h2>
          <p class="px-2 font-weight-medium">
            Certificado de Excelência
            <br />
            Organização Pan-Americana da Saúde/Organização Mundial da Saúde (OPAS/OMS)
            <br />
            Fundação Municipal de Saúde de Niterói (FMS)
          </p>
          <a class="certificado" open-image="certOpas.jpeg"> 
            Certificação 
          </a>
        </article>

        <h2 class="gradient-text">
          <img
            src="https://cdn-icons-png.flaticon.com/512/3208/3208892.png"
            class="mr-3"
            style="max-width: 24px; max-height: 24px"
          ></img>  
          Demais matérias de destaque
        </h2>
        <p>
          <a target="_blank" href="https://www.uff.br/08-02-2023/prev-ist-aplicativo-criado-por-aluno-da-uff-esclarece-duvidas-sobre-saude-sexual-para-diversos-publicos/">
            Prev-IST: aplicativo criado por aluno da UFF esclarece dúvidas sobre saúde sexual para diversos públicos
          </a>
        </p>
        <p>
          <a target="_blank" href="https://www.brasildefato.com.br/2023/03/07/estudante-da-uff-cria-aplicativo-voltado-para-educacao-sexual-e-combate-a-ists">
            Estudante da UFF cria aplicativo voltado para educação sexual e combate à ISTs
          </a>
        </p>
        <p>
          <a target="_blank" href="https://apsredes.org/prev-ist-aplicativo-movel-sobre-educacao-sexual-para-adolescentes/">
            PREV IST: Aplicativo móvel sobre educação sexual para adolescentes
          </a>
        </p>
        <p>
          <a target="_blank" href="https://tecnologiasocial.uff.br/?p=7086">
            #TSENTREVISTA: Saúde Coletiva em foco: conheça o aplicativo Prev-IST e o trabalho desenvolvido pelo professor Jorge Luiz Lima, da UFF
          </a>
        </p>
        <p>
          <a target="_blank" href="https://www.uff.br/17-12-2024/aplicativo-simplifica-a-educacao-de-adolescentes-sobre-o-hpv/">
            Aplicativo simplifica a educação de adolescentes sobre o HPV
          </a>
        </p>
        <iframe 
          width="350"
          height="200" 
          src="https://www.youtube.com/embed/b-9wAtI0O4E?si=ryzNpXxA9RKwAW7u" 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    `,
  },
];
